import { Badge as FluentBadge } from '@fluentui/react-components';
import type { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  color?: 'brand' | 'danger' | 'important' | 'informative' | 'severe' | 'subtle' | 'success' | 'warning';
  size?: 'tiny' | 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large';
  appearance?: 'filled' | 'ghost' | 'outline' | 'tint';
}

export function Badge({ children, color = 'informative', size = 'medium', appearance = 'filled' }: BadgeProps) {
  return (
    <FluentBadge color={color} size={size} appearance={appearance}>
      {children}
    </FluentBadge>
  );
}

// Predefined urgency badges
export function UrgencyBadge({ level }: { level: 'low' | 'medium' | 'high' }) {
  const config = {
    low: { color: 'success' as const, label: 'Low Priority' },
    medium: { color: 'warning' as const, label: 'Medium Priority' },
    high: { color: 'danger' as const, label: 'High Priority' },
  };

  const { color, label } = config[level];

  return (
    <Badge color={color} size="small">
      {label}
    </Badge>
  );
}

// Confidence badge
export function ConfidenceBadge({ confidence }: { confidence: number }) {
  const percentage = Math.round(confidence * 100);
  let color: BadgeProps['color'] = 'success';

  if (confidence < 0.6) {
    color = 'danger';
  } else if (confidence < 0.8) {
    color = 'warning';
  }

  return (
    <Badge color={color} size="small" appearance="outline">
      {percentage}% confident
    </Badge>
  );
}
